<div class="row" style="padding: 0">
  @if (!isLoading && !noData) {
    <div>
      <app-highcharts-generic
        [chartheight]="height"
        [options]="utilization_options"
        [series]="utilization_series"
      ></app-highcharts-generic>
    </div>
  }
</div>

@if (!isLoading && noData) {
  <div class="noDataZiti">No Data</div>
}
<app-loader [isLoading]="isLoading"></app-loader>
